"use client";

import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Edit, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom'; // Added for navigation

interface Project {
  id: string;
  name: string;
  description: string;
  status: string;
}

interface ProjectCardProps {
  project: Project;
  onEdit: (project: Project) => void;
  onDelete: (id: string) => void;
}

export const ProjectCard: React.FC<ProjectCardProps> = ({ project, onEdit, onDelete }) => {
  const navigate = useNavigate(); // Added for navigation

  // Helper to handle navigation (if needed, e.g., for viewing project)
  const handleViewProject = () => {
    navigate(`/dashboard/projects/${project.id}`);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-start">
          <button onClick={handleViewProject} className="text-lg font-medium hover:underline">
            {project.name}
          </button>
          <Badge variant={project.status === 'active' ? "default" : "secondary"}>{project.status}</Badge>
        </CardTitle>
        <CardDescription>{project.description}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex space-x-2">
          <Button variant="outline" size="sm" onClick={() => onEdit(project)}>
            <Edit className="h-4 w-4 mr-1" />
            Edit
          </Button>
          <Button variant="destructive" size="sm" onClick={() => onDelete(project.id)}>
            <Trash2 className="h-4 w-4 mr-1" />
            Delete
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};